"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendUrl = void 0;
const appendUrl = (srcUrl, queryParams) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queryParameterString = Object.keys(queryParams)
        .map((key) => `${key}=${queryParams[key]}`)
        .join('&');
    /**
     * For the urls like htttps://domain.com/images/123.jpeg?width=234
     */
    if (/.*\?((.*=.*)(&?))+/g.test(srcUrl)) {
        return `${srcUrl}&${queryParameterString}`;
    }
    /**
     * For the urls like htttps://domain.com/images/123.jpeg?
     */
    if (/.*\?((.*=.*)(&?))+|(.*\?)/g.test(srcUrl)) {
        return `${srcUrl}${queryParameterString}`;
    }
    /**
     * For the urls like htttps://domain.com/images/123.jpeg
     */
    return `${srcUrl}?${queryParameterString}`;
};
exports.appendUrl = appendUrl;
//# sourceMappingURL=append-url.js.map